import { AddressDetails } from "./Address";

export class LocationRequest {
  id = null;
  name = "";
  address = new AddressDetails();
  regionID = null;
  orgId = "";
}
